export enum CouponUsageTypes {
  SingleUse = 1,
  OncePerCustomer,
  Unlimited
}

export enum TestVisitTypes {
  Home = 1,
  Branch,
  All
}

export enum TestPercentageSections {
  EligibleTests = 1,
  HomeVisitFees,
  All
}

export enum TestTypes {
  Default,
  Lab,
  Scan,
  All,
  Physiotherapy
}
